import script from "./inputAreaAuto2.vue?vue&type=script&setup=true&lang=ts"
export * from "./inputAreaAuto2.vue?vue&type=script&setup=true&lang=ts"

import "./inputAreaAuto2.vue?vue&type=style&index=0&id=46c0c28d&scoped=true&lang=css"

import exportComponent from "/home/aschmuck/wk/eSklepios/medsw/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-46c0c28d"]])

export default __exports__